import { FunctionComponent, useState, useCallback } from 'react'
import { MdPlayArrow } from 'react-icons/md'

import * as Yup from 'yup'

import { steps } from '../../'
import iconEndereco from 'shared/assets/icons/icon-endereco.png'
import Form, { IProps as FormProps } from 'shared/components/Form'
import Input from 'shared/components/Input'
import Page from 'shared/components/Page'
import { colors } from 'shared/styles/colors'
import { IFullAddressProps } from './FullAddressComponent.types'
import { ContainerForm, StyledButton, ContainerButton } from './styles'

const FullAddress: FunctionComponent<IFullAddressProps> = ({
  address,
  setSelectedStep,
}) => {
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const [cep] = useState(() => {
    if (localStorage.getItem('@TMov:SignUpCep')) {
      return localStorage.getItem('@TMov:SignUpCep')
    }

    return address.cep ? address.cep : ''
  })
  const [cidade] = useState(() => {
    if (localStorage.getItem('@TMov:SignUpCidade')) {
      return localStorage.getItem('@TMov:SignUpCidade')
    }

    return address.cidade ? address.cidade : ''
  })
  const [estado] = useState(() => {
    if (localStorage.getItem('@TMov:SignUpEstado')) {
      return localStorage.getItem('@TMov:SignUpEstado')
    }

    return address.estado ? address.estado : ''
  })
  const [logradouro] = useState(() => {
    if (localStorage.getItem('@TMov:SignUpLogradouro')) {
      return localStorage.getItem('@TMov:SignUpLogradouro')
    }

    return address.logradouro ? address.logradouro : ''
  })
  const [numero] = useState(() => {
    if (localStorage.getItem('@TMov:SignUpNumero')) {
      return localStorage.getItem('@TMov:SignUpNumero')
    }

    return ''
  })
  const [bairro] = useState(() => {
    if (localStorage.getItem('@TMov:SignUpBairro')) {
      return localStorage.getItem('@TMov:SignUpBairro')
    }

    return address.bairro ? address.bairro : ''
  })
  const [complemento] = useState(() => {
    if (localStorage.getItem('@TMov:SignUpComplemento')) {
      return localStorage.getItem('@TMov:SignUpComplemento')
    }

    return ''
  })

  const handleSubmit = useCallback(
    async (values: FormProps['values']) => {
      setLoading(true)
      setErrorMessage('')

      try {
        const schema = Yup.object().shape({
          street: Yup.string().required(),
          neighborhood: Yup.string().required(),
        })

        await schema.validate(values, {
          abortEarly: false,
        })

        localStorage.setItem('@TMov:SignUpCep', address.cep)
        localStorage.setItem('@TMov:SignUpCidadeIBGE', address.cidade_ibge)
        localStorage.setItem('@TMov:SignUpCidade', address.cidade)
        localStorage.setItem('@TMov:SignUpEstado', address.estado)
        localStorage.setItem('@TMov:SignUpLogradouro', values.street)
        localStorage.setItem('@TMov:SignUpNumero', values.number)
        localStorage.setItem('@TMov:SignUpBairro', values.neighborhood)
        localStorage.setItem('@TMov:SignUpComplemento', values.complement)

        setLoading(false)
        setSelectedStep(steps.Antt)
      } catch (e: unknown) {
        setLoading(false)

        if (e instanceof Yup.ValidationError) {
          setErrorMessage('Os campos Rua e Bairro são obrigatórios')
        } else if (e instanceof Error) {
          setErrorMessage(e.message)
        } else {
          setErrorMessage('Erro ao tentar submeter o formulário')
        }
      }
    },
    [address, setSelectedStep],
  )

  return (
    <Page
      icon={iconEndereco}
      title="Perfeito!<br />Agora seu endereço:"
      goBackTo={() => {
        setSelectedStep(steps.Photo)
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'center', flex: 1 }}>
        <Form
          onSubmit={handleSubmit}
          initialValues={{
            cep: cep,
            street: logradouro,
            number: numero,
            complement: complemento,
            neighborhood: bairro,
            city: cidade,
            state: estado,
          }}
          validationSchema={() => ({
            cep: Yup.string().required(),
            street: Yup.string().required(),
            number: Yup.number().required(),
            complement: Yup.string().optional(),
            neighborhood: Yup.string().required(),
            city: Yup.string().required(),
            state: Yup.string().required(),
          })}
        >
          {formControl => (
            <ContainerForm>
              <Input
                placeholder="04469-000"
                name="cep"
                type="text"
                formControl={formControl}
                errorMessage={''}
                disabled={true}
              />
              <Input
                placeholder="Logradouro"
                name="street"
                type="text"
                formControl={formControl}
                errorMessage={''}
              />
              <Input
                placeholder="Número"
                name="number"
                type="number"
                formControl={formControl}
                errorMessage={''}
              />
              <Input
                placeholder="Complemento"
                name="complement"
                type="text"
                formControl={formControl}
                errorMessage={''}
              />
              <Input
                placeholder="Bairro"
                name="neighborhood"
                type="text"
                formControl={formControl}
                errorMessage={''}
              />
              <Input
                placeholder="Cidade"
                name="city"
                type="text"
                formControl={formControl}
                errorMessage={''}
                disabled={true}
              />
              <Input
                placeholder="UF"
                name="state"
                type="text"
                formControl={formControl}
                errorMessage={errorMessage}
                disabled={true}
              />
              <ContainerButton>
                <StyledButton
                  color={colors.green}
                  type="submit"
                  loading={loading}
                  onClick={formControl.handleSubmit}
                >
                  <MdPlayArrow /> Próximo
                </StyledButton>
              </ContainerButton>
            </ContainerForm>
          )}
        </Form>
      </div>
    </Page>
  )
}

export default FullAddress
